/**
 * Get brand string and id from window, or GraphQL id param
 * @param  {Any} id Brand id or string, unnecessary if window !== 'undefined'
 * @return {Object} brandId: int; brandName: string;
 */

export const getBrand = id => {
  const fullPath = typeof window !== 'undefined' ? window.location.href : '';
  if (fullPath !== '') {
    return getBrandByPath(fullPath);
  }
  return getBrandById(id);
};

const getBrandById = id => {
  const brandId = id;
  let brandName;
  switch (id) {
    case 1:
      brandName = 'hotwater';
      break;
    case 2:
      brandName = 'whirlpool';
      break;
    case 6:
      brandName = 'state';
      break;
    case 8:
      brandName = 'lowes';
      break;
    default:
      brandName = 'hotwater';
  }
  return { brandId, brandName };
};

const getBrandByPath = fullPath => {
  let brandId;
  let brandName;

  if (fullPath.indexOf('hotwater') !== -1) {
    brandId = 1;
    brandName = 'hotwater';
  } else if (fullPath.indexOf('whirlpool') !== -1) {
    brandId = 2;
    brandName = 'whirlpool';
  } else if (fullPath.indexOf('state') !== -1) {
    brandId = 6;
    brandName = 'state';
  } else if (fullPath.indexOf('lowes') !== -1) {
    brandId = 8;
    brandName = 'lowes';
  } else {
    // When running program locally:
    // change this to current brand
    brandId = 1;
    brandName = 'hotwater';
  }

  return { brandId, brandName };
};



// WEBPACK FOOTER //
// ./src/utils/brand/getBrand.js